import { render, staticRenderFns } from "./AdminTemplate.vue?vue&type=template&id=3aea843e&scoped=true"
import script from "./AdminTemplate.vue?vue&type=script&lang=js"
export * from "./AdminTemplate.vue?vue&type=script&lang=js"
import style0 from "./AdminTemplate.vue?vue&type=style&index=0&id=3aea843e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aea843e",
  null
  
)

export default component.exports